









import { Vue, Component } from 'vue-property-decorator';
import Form from './Steps/Form.vue';
import Processing from './Steps/Processing.vue';

enum ECreateStepSlug {
  FORM = 'form',
  PROCESSING = 'processing'
}

@Component({
  components: { Form, Processing }
})
export default class InviteCustomerInStoreCreate extends Vue {
  activeStepSlug: ECreateStepSlug = ECreateStepSlug.FORM;

  get componentByStepSlug() {
    return {
      [ECreateStepSlug.FORM]: {
        component: 'Form'
      },
      [ECreateStepSlug.PROCESSING]: {
        component: 'Processing'
      }
    };
  }

  onFinish() {
    this.activeStepSlug = ECreateStepSlug.PROCESSING;
  }
}
